import _      from 'lodash';
import moment from 'moment';

// boolean
export const translateBool = bool => bool ? 'ano' : 'ne';

// array
export function extractLast(array) {
  const butLast = array.slice(0, array.length - 1);
  const last    = _.last(array);

  return [butLast, last];
}

// string
const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]{2,}$/;

export const isValidEmail = email => emailRegex.test(email);

// object
const EMPTY_VALUES = [undefined, null, '', [], {}];

export const isEmpty = value => EMPTY_VALUES.includes(value);

export const removeEmptyAttrs = obj => _.omitBy(obj, val => EMPTY_VALUES.includes(val))
export const removeFalsyAttrs = obj => _.pickBy(obj, _.identity)

// date
export const dateFormat = 'YYYY-MM-DD';

export const momentComparator = (moment1, moment2) => moment1.isBefore(moment2) ? -1 : 0;

export const formatDate = mmnt          => mmnt.format(dateFormat);
export const parseDate  = formattedDate => moment(formattedDate, dateFormat)

export const dateAfterNDays = (startDate, n) => startDate.clone().add(n, 'days');

export function datesInInterval(start, end) {
  const first = start.startOf('day');
  const dates = [first];

  let current = first;

  while (true) {
    current = current.clone().add(1, 'day');

    if (current.isAfter(end)) { return dates; }

    dates.push(current);
  }
};

// location
export function currentLocation() {
  const { pathname, hash, search } = window.location;

  return { pathname, hash, query: parseQueryString(search) };
};

export function parseQueryString(queryString) {
  return _.fromPairs(queryString.replace('?', '').split('&').map(param => param.split('=')));
}
